import React from "react";
import { Link, Outlet } from "react-router-dom";
// import "../../../css/Comments.module.css";

const CommentManagement = () => (
  <div className="comment-management">
    <h1>مدیریت نظرات</h1>
    <div className="comment-management-actions">
      <Link to="list" className="comment-management-button">
        لیست نظرات
      </Link>     
    </div>
    <div className="comment-management-content">
      <Outlet />
    </div>
  </div>
);

export default CommentManagement;
